<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <div>
          <div>
            <h6 class="heading-small text-muted mb-4">Template</h6>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="selectedAccountReportTemplateId"
                  style="width: 100%"
                  placeholder="Select Template"
                  :filter-option="filterOption"
                  @change="
                    (event) => {
                      setAccountReportTemplate(event);
                      setOrigConfig(event);
                    }
                  "
                >
                  <a-select-option
                    v-for="template in options.accountReportTemplates"
                    :value="template.id"
                    :key="template.id"
                    :label="template.name"
                  >
                    {{ template.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
        </div>
        <br />
        <form role="form" @submit.prevent>
          <h6 class="heading-small text-muted mb-4">Filters</h6>
          <div>
            <div>
              <label>Report Type Display</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.report_type"
                  style="width: 100%"
                  placeholder="Select Report Type"
                  :filter-option="filterOption"
                  @change="onChangeReportType"
                >
                  <a-select-option
                    v-for="reportType in options.reportTypes"
                    :value="reportType.id"
                    :key="reportType.id"
                    :label="reportType.name"
                  >
                    {{ reportType.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Membership Program</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.membership_program_ids"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Membership Programs"
                >
                  <a-select-option
                    v-for="membershipProgram in options.membershipPrograms"
                    :value="membershipProgram.id"
                    :key="membershipProgram.id"
                    :label="membershipProgram.name"
                  >
                    {{ membershipProgram.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div v-if="!hasCardAssignmentModule">
            <div>
              <label>Batch No.</label>
            </div>
            <div class="row">
              <div class="col">
                <base-input>
                  <a-input
                    placeholder="Batch No."
                    v-model="table.appendedParams.batch_no"
                    v-on:keyup.enter="setFilter"
                  />
                </base-input>
              </div>
            </div>
          </div>
          <div v-if="!hasCardAssignmentModule">
            <div>
              <label>Card Type</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.card_type_ids"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Card Types"
                >
                  <a-select-option
                    v-for="cardType in options.cardTypes"
                    :value="cardType.id"
                    :key="cardType.id"
                    :label="cardType.name"
                  >
                    {{ cardType.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Site</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.site_ids"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Sites"
                >
                  <a-select-option
                    v-for="site in options.sites"
                    :value="site.id"
                    :key="site.id"
                    :label="site.name"
                  >
                    {{ site.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>

          <div>
            <div>
              <label>Date </label>
            </div>
            <div class="row">
              <div class="col">
                <base-input>
                  <a-range-picker
                    v-model="table.appendedParams.date_range"
                    :default-value="[
                      table.appendedParams.date_from,
                      table.appendedParams.date_to
                    ]"
                    :format="dateFormat"
                    @change="dateRangeOnChange"
                  />
                </base-input>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Card Status</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.card_status_ids"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select card status"
                >
                  <a-select-option
                    v-for="cardStatus in options.cardStatuses"
                    :value="cardStatus.id"
                    :key="cardStatus.id"
                    :label="cardStatus.name"
                  >
                    {{ cardStatus.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <base-button
                type="primary btn-block"
                class="my-4"
                @click.prevent="applyFilter"
              >
                <div>Apply Filter</div>
              </base-button>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.appendedParams"
          :sortOrder="table.sortOrder"
          :sortParams="getSortParam"
          :multiSort="table.multiSort"
          :multiSortKey="table.multiSortKey"
        >
          <template #headerButtons>
            <div>
              <b-button
                v-if="selectedActions.includes('Customize')"
                variant="primary"
                @click.prevent="openDrawer('report_template')"
                >Customize</b-button
              >
              <b-button
                v-if="
                  selectedActions.includes('Download') ||
                  selectedActions.includes('Send')
                "
                variant="danger"
                @click.prevent="openDrawer('export_data')"
                >Export</b-button
              >
            </div>
            <!-- <base-dropdown class="nav-link pr-0 float-right" position="right">
              <div class="media align-items-center" slot="title">
                <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
              </div>
              <template>
                <div class="dropdown-header noti-title">
                  <h6 class="text-overflow m-0">ACTIONS</h6>
                </div>
                <div
                  class="dropdown-item"
                  @click.prevent="openDrawer('export_data')"
                >
                  <i class="fa fa-download"></i>
                  <span>Export Data</span>
                </div>
                <div
                  class="dropdown-item"
                  @click.prevent="openDrawer('report_template')"
                >
                  <i class="fa fa-list-ul"></i>
                  <span>Report Template</span>
                </div>
              </template>
            </base-dropdown> -->
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <AccountReportTemplate
                v-if="drawer.action == 'report_template'"
                :accountReport="accountReport"
                :accountReportTemplate="accountReportTemplate"
                :selectedAccountReportTemplateColumns="tableFields"
                :selectedAccountReportTemplateFilters="table.appendedParams"
                :selectedAccountReportTemplateSorts="table.sortOrder"
                :updatedFilter="updatedFilters"
                @setTableColumns="setTableColumns"
                @setAccountReportTemplate="getAccountReportData"
                @deleteAccountReportTemplate="getAccountReportData"
                @closeDrawer="closeDrawer"
                @setUpdatedFilter="updatedFilters = false"
              />

              <ExportDataForm
                v-if="drawer.action == 'export_data'"
                :jsonFields="toJsonFields"
                :template="selectedAccountReportTemplateId"
                :filename="filename"
                :apiUrl="tableApiUrl"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import HTTPRequest from '../../../controllers/httpRequest';
import PageHeader from '../../../components/Page/Header.vue';
import PageContent from '../../../components/Page/Content.vue';
import PageTable from '../../../components/Page/Table.vue';
import AccountReportTemplate from '../Drawers/AccountReportTemplateForm.vue';
import ExportDataForm from '../Drawers/ExportDataForm.vue';
import { mapGetters } from 'vuex';
import secureStorage from '../../../controllers/secureStorage';
import moment from 'moment-timezone';
const ENV = process.env.VUE_APP_ENV;
const TIMEZONE = process.env.VUE_APP_TIMEZONE || 'Asia/Singapore';
let dateFormat = 'YYYY-MM-DD h:mm A';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    AccountReportTemplate,
    ExportDataForm
  },
  data() {
    return {
      filename: `Report - ${moment().format('YYYY-MM-DDTHHmmss.SSS')}.csv`,
      reloadTbl: true,
      hasCardAssignmentModule: false,
      updatedFilters: false,
      originalFilter: null,
      dateFormat: 'YYYY-MM-DD',
      gradientType: 'gradient-yellow',
      accountReport: null,
      accountReportTemplate: null,
      selectedAccountReportTemplateId: null,
      saveFilters: false,
      saveSorts: false,
      drawer: {
        visible: false,
        width: 600,
        placement: 'right',
        action: null
      },
      table: {
        title: 'Card Reports',
        apiUrl:
          '/api/v1/reports/cards?origin_site_id=' +
          secureStorage.getItem('currentSiteId'),
        fields: [],
        appendedParams: {
          membership_program_ids: [],
          card_type_ids: [],
          site_ids: [],
          card_status_ids: [],
          date_range: [
            moment(new Date()).format('YYYY-MM-DD'),
            moment(new Date()).format('YYYY-MM-DD')
          ],
          date_from: moment(new Date()).format('YYYY-MM-DD'),
          date_to: moment(new Date()).format('YYYY-MM-DD'),
          report_type: 'aggregate',
          batch_no: null,
          export_data: false,
          template: null,
          filter: false
        },
        multiSort: true,
        multiSortKey: 'alt',
        sortOrder: [
          {
            field: 'id',
            direction: 'desc'
          }
        ]
      },
      options: {
        membershipPrograms: [],
        cardTypes: [],
        sites: [],
        reportTypes: [
          { id: 'aggregate', name: 'Consolidated' },
          { id: 'list', name: 'Listing' }
        ],
        reportTemplates: [],
        accountReportTemplates: null,
        cardStatuses: []
      }
    };
  },
  methods: {
    async getCardAssignmentFeature() {
      const response = await HTTPRequest.getRequest(
        `/api/v1/clp_accounts/settings/CARD_ASSIGNMENT_FEATURE`
      );

      if (response.account_id) {
        this.hasCardAssignmentModule = response.value == 'true';
      }
    },
    filterOption(inputValue, option) {
      return (
        option?.componentOptions?.propsData?.label
          .toLowerCase()
          .indexOf(inputValue.toLowerCase()) !== -1
      );
    },
    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs'
      );
      this.options.membershipPrograms = response.data;
    },

    async getCardTypes() {
      const response = await HTTPRequest.getRequest('/api/v1/clp_card_types');
      this.options.cardTypes = response.data;
    },

    async getSites() {
      const defaultSite = secureStorage.getItem('defaultSite');
      if (this.inHeadOffice) {
        this.options.sites = secureStorage.getItem('visitingSites');
      } else {
        this.options.sites = [secureStorage.getItem('currentSite')];
      }
      this.table.appendedParams.site_ids.push(defaultSite.id);
    },

    async getCardStatuses() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_card_statuses'
      );
      let data = [];
      for (let x in response.data) {
        if (response.data[x].model == 'cards') {
          data.push(response.data[x]);
        }
      }
      this.options.cardStatuses = data;
    },

    async getAccountReportData() {
      const reportType = this.table.appendedParams.report_type;
      let accountReport = [];

      switch (reportType.toLowerCase()) {
        case 'aggregate':
          accountReport = await HTTPRequest.getRequest(
            '/api/v1/account_reports/CARD_REPORTS_AGGREGATE/default'
          );
          break;

        case 'list':
          accountReport = await HTTPRequest.getRequest(
            '/api/v1/account_reports/CARD_REPORTS_LIST/default'
          );
          break;
      }

      this.accountReport = accountReport;
      await this.setAccountReportTemplate(
        accountReport.accountReportTemplates[0]
      );
      this.setOrigConfig(accountReport.accountReportTemplates[0]);
      await this.getAccountReportTemplates();
    },
    async getAccountReportTemplates() {
      const data = await HTTPRequest.getRequest(
        '/api/v1/account_report_templates/' +
          this.accountReport.code +
          '/templates'
      );
      this.options.accountReportTemplates = data;
    },

    setAccountReportTemplate(accountReportTemplate) {
      let accountReportTemplateData;
      if (typeof accountReportTemplate == 'number') {
        this.selectedAccountReportTemplateId = accountReportTemplate;
        for (const template of this.options.accountReportTemplates) {
          if (accountReportTemplate == template.id) {
            this.accountReportTemplate = template;
            accountReportTemplateData = JSON.parse(template.config);
          }
        }
      } else {
        this.accountReportTemplate = accountReportTemplate;
        accountReportTemplateData = JSON.parse(accountReportTemplate.config);
        this.selectedAccountReportTemplateId = accountReportTemplate.id;
      }

      /** Clear the previous' template's filter/s */
      this.clearTableFilters();

      /** Clear the previous' template's sort/s */
      this.clearTableSorts();

      /** Load template's default columns */
      this.setTableColumns(accountReportTemplateData.columns);

      if (
        accountReportTemplateData.filters &&
        Object.keys(accountReportTemplateData.filters).includes('source')
      ) {
        const spreadFilter = { ...accountReportTemplateData.filters };
        delete spreadFilter['source'];
        accountReportTemplateData.filters = spreadFilter;
      }
      /** Load template's default filters */
      this.setTableFilters(accountReportTemplateData.filters);

      /** Load template's default sort */
      this.setTableSorts(accountReportTemplateData.sorts);
    },

    setTableColumns(columns = []) {
      /**
       * Note: Amongst the other 2 methods on clearing the table fields,
       * this one worked as this doesn't alter the original array instance
       *
       * this.table.fields = this.table.fields.splice(0, this.table.fields.length);
       * this.table.fields = [];
       * */
      /** Clear table fields */
      this.table.fields.length = 0;
      let type = this.table.appendedParams.report_type;
      const tableFields = this.table.fields;
      if (type === 'aggregate') {
        dateFormat = 'YYYY-MM-DD';
      } else {
        dateFormat = 'YYYY-MM-DD h:mm A';
      }
      // hasCardAssignmentModule
      if (this.hasCardAssignmentModule) {
        columns = columns.filter(
          (item) =>
            item.name !== 'serial_no' &&
            item.name !== 'batch_number' &&
            item.name !== 'barcode' &&
            item.name !== 'card_type_name'
        );
      }
      columns.forEach((column) => {
        /** Check if current "column" is already in the table */ ``;
        let hasField = tableFields.find((field) => field.name === column.name);
        if (typeof hasField === 'undefined') {
          if (Object.keys(column).includes('value')) {
            if (
              this.table.appendedParams.report_type == 'aggregate' &&
              column.name == 'date'
            ) {
              dateFormat = 'YYYY-MM-DD';
            }
            if (column.value) {
              /** Push to table */
              if (column.name == 'date') {
                column.formatter = function (date) {
                  if (moment(date).isValid()) {
                    if (ENV === 'development') {
                      return moment(date).format(dateFormat);
                    } else {
                      return moment.utc(date).tz(TIMEZONE).format(dateFormat);
                    }
                  }
                  return null;
                };
              }
              this.table.fields.push(column);
            }
          } else {
            /** Push to table */
            console.log('Pushing column: ', column.name);
            if (column.name == 'date') {
              column.formatter = function (date) {
                if (moment(date).isValid()) {
                  if (ENV === 'development') {
                    return moment(date).format(dateFormat);
                  } else {
                    return moment.utc(date).tz(TIMEZONE).format(dateFormat);
                  }
                }
                return null;
              };
            }
            this.table.fields.push(column);
          }
        }
      });
    },

    setTableFilters(filters = {}) {
      if (Object.keys(filters).length !== 0) {
        this.table.appendedParams = filters;
        // setTimeout(() => this.setFilter(), 200);
      }
    },

    setTableSorts(sorts = []) {
      if (sorts && sorts.length > 0) {
        this.table.sortOrder = sorts;
        // setTimeout(() => this.setFilter(), 200);
      } else {
        this.table.sortOrder = sorts;
      }
    },

    getSortParam(sortOrder) {
      return sortOrder
        .map(function (sort) {
          return sort.field + '|' + sort.direction;
        })
        .join(',');
    },

    async onChangeReportType() {
      this.reloadTbl = false;
      /** Get report data for the report type */
      await this.getAccountReportData();

      /** Clear filters for the table */
      this.clearTableFilters();

      /** Reload table */
      this.setFilter();
    },

    clearTableFilters() {
      this.table.appendedParams.membership_program_ids = [];
      this.table.appendedParams.card_type_ids = [];
      this.table.appendedParams.site_ids = [];
      this.table.appendedParams.card_status_ids = [];
      this.table.appendedParams.batch_no = null;
      this.table.appendedParams.dates = [];
      this.table.appendedParams.template = null;
      this.table.appendedParams.date_range = [
        moment(new Date()).format('YYYY-MM-DD'),
        moment(new Date()).format('YYYY-MM-DD')
      ];
      this.table.appendedParams.date_from = moment(new Date()).format(
        'YYYY-MM-DD'
      );
      this.table.appendedParams.date_to = moment(new Date()).format(
        'YYYY-MM-DD'
      );
    },

    clearTableSorts() {
      this.table.sortOrder = null;
    },

    openDrawer(action) {
      this.drawer.visible = true;
      this.drawer.action = action;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.drawer.action = null;
    },
    applyFilter() {
      this.reloadTbl = true;
      this.table.appendedParams.filter = true;
      this.table.appendedParams.template = this.selectedAccountReportTemplateId;
      this.setFilter();
    },
    setFilter() {
      this.originalFilter === JSON.stringify(this.table.appendedParams)
        ? (this.updatedFilters = false)
        : (this.updatedFilters = true);

      if (
        this.table.appendedParams.date_from != '' &&
        this.table.appendedParams.date_from
      ) {
        this.table.appendedParams.date_from =
          this.table.appendedParams.date_range[0];
        let dateFrom = moment(this.table.appendedParams.date_from);
        this.table.appendedParams.date_from = dateFrom
          .tz('UTC')
          .format('YYYY-MM-DD HH:mm:ss');
      }
      if (
        this.table.appendedParams.date_to != '' &&
        this.table.appendedParams.date_to
      ) {
        this.table.appendedParams.date_to =
          this.table.appendedParams.date_to.split(' ')[0];
        let dateTo = moment(this.table.appendedParams.date_to)
          .add(1, 'day')
          .subtract(1, 'second');
        this.table.appendedParams.date_to = dateTo
          .tz('UTC')
          .format('YYYY-MM-DD HH:mm:ss');
      }
      if (this.reloadTbl) {
        this.$root.$emit('refreshTable');
      }
    },

    dateRangeOnChange(dateObj, dateString) {
      this.table.appendedParams.date_from = dateString[0];
      this.table.appendedParams.date_to = dateString[1];
      this.table.appendedParams.date_range = [dateString[0], dateString[1]];

      // this.setFilter();
    },
    serializeQuery(params, prefix) {
      if (params) {
        const query = Object.keys(params).map((key) => {
          const value = params[key];

          if (params.constructor === Array) {
            key = `${prefix}[]`;
          } else if (params.constructor === Object) {
            key = prefix ? `${prefix}[${key}]` : key;
          }

          if (typeof value === 'object') {
            return this.serializeQuery(value, key);
          } else {
            return `${key}=${encodeURIComponent(value)}`;
          }
        });
        let serializedQuery = query.filter((elem) => elem != '');
        return [].concat.apply([], serializedQuery).join('&');
      }
    },
    setOrigConfig(event) {
      if (typeof event == 'number') {
        for (const template of this.options.accountReportTemplates) {
          if (event == template.id) {
            const jConfig = JSON.parse(template.config);
            if (Object.keys(jConfig).includes('filter')) {
              this.originalFilter = JSON.stringify(
                JSON.parse(jConfig.config).filters
              );
            } else {
              this.originalFilter = JSON.stringify(this.table.appendedParams);
            }
          }
        }
      } else {
        const jConfig = JSON.parse(event.config);
        if (Object.keys(jConfig).includes('filter')) {
          this.originalFilter = JSON.stringify(jConfig.filters);
        } else {
          this.originalFilter = JSON.stringify(this.table.appendedParams);
        }
      }
    }
  },
  async created() {
    await this.getCardAssignmentFeature();
    this.$store.dispatch('setCurrentModule', 'CardReport');
    await this.getMembershipPrograms();
    await this.getCardTypes();
    await this.getSites();
    await this.getCardStatuses();
    await this.getAccountReportData();
  },
  watch: {
    inHeadOffice: function () {
      if (this.inHeadOffice) {
        this.options.sites = secureStorage.getItem('visitingSites');
      } else {
        this.options.sites = [secureStorage.getItem('currentSite')];
      }
    }
  },
  computed: {
    tableFields() {
      const _tableFields = [...this.table.fields];
      return _tableFields;
    },

    ...mapGetters({
      selectedActions: 'getModuleSelectedActions',
      headOfficeId: 'getHeadOffice'
    }),
    inHeadOffice() {
      return secureStorage.getItem('currentSiteId') == this.headOfficeId
        ? true
        : false;
    },

    tableApiUrl() {
      const tableApiUrl = this.table.apiUrl;
      let _tableParams = { ...this.table.appendedParams };
      _tableParams.export_data = true; // Update to true, for exportable data
      const _tableSort = [...this.table.sortOrder];
      let sorts, filters;

      /** Create query string for "sort" first if there are sorting */
      if (_tableSort.length > 0) {
        let i = 0;
        for (let sort of _tableSort) {
          if (i == 0) {
            sorts = 'sort=' + sort.field + '|' + sort.direction;
          } else {
            sorts += ',' + sort.field + '|' + sort.direction;
          }
          i++;
        }
      }

      /** Parse object for query string */
      filters = this.serializeQuery(_tableParams);
      if (tableApiUrl.includes('?')) {
        return tableApiUrl + '&' + sorts + '&' + filters;
      } else {
        return tableApiUrl + '?' + sorts + '&' + filters;
      }
    },

    toJsonFields: function () {
      const _tableFields = [...this.table.fields];
      let jsonFields = {};
      let dateFormat = 'YYYY-MM-DD h:mm A';
      if (this.table.appendedParams.report_type == 'aggregate') {
        dateFormat = 'YYYY-MM-DD';
      }
      for (let field of _tableFields) {
        jsonFields[field.title] = field.name;
        switch (field.name) {
          case 'barcode':
          case 'card_number':
          case 'serial_no':
            jsonFields[field.title] = {
              field: field.name,
              callback: (value) => {
                return '="' + value + '"';
              }
            };
            break;
          case 'card_expired_at':
          case 'date':
            jsonFields[field.title] = {
              field: field.name,
              callback: (date) => {
                if (moment(date).isValid()) {
                  if (ENV === 'development') {
                    return moment(date).format(dateFormat);
                  } else {
                    return moment.utc(date).tz(TIMEZONE).format(dateFormat);
                  }
                }
                return null;
              }
            };
            break;
        }
      }

      return jsonFields;
    }
  }
};
</script>

<style scoped></style>
